import {
  Appointment,
  BoundingBox,
  Claim,
  Configuration,
  Dossier,
  Fitter,
  GeoCoordinates,
  LocationDataGeocoded,
  NotifyAction,
} from '../commons';

export interface CancelAppointmentApi {
  dossierId: string;
  comment?: string;
  notifyClient?: boolean;
}

export interface GoogleConversionTracking {
  rwgToken: string;
  partnerId: string;
}

export interface BookAppointmentApi {
  dossier: Dossier;
  googleConversionTracking?: GoogleConversionTracking;
}

export interface RequestAppointmentApi {
  dossier: Dossier;
}

export interface ModifyAppointmentApi {
  dossier: Dossier;
}

export interface BookAppointmentApiResponse {
  dossier: Dossier;
  dossierForContractManager?: any;
}

export interface RequestAppointmentApiResponse {
  dossier: Dossier;
  dossierForContractManager?: any;
}

export interface ModifyAppointmentApiResponse {
  dossier: Dossier;
  dossierForContractManager?: any;
}

export interface FetchFreeSlotsApi {
  clientKey: string;
  replacementVehicle: boolean;
  searchDates: { startDate: Date; endDate: Date };
  claim: Partial<Claim>;
  config?: Configuration;
  clientData?: any;
  searchLocation: SearchLocation;
  excludeFitters?: string[];
  outsideIntervention: boolean;
  fitterId?: string;
  returnFittersOnly?: boolean;
  businessOrigin?: string;
  knownFitters?: KnownFitterDistance[];
}

export interface SearchLocation {
  address: LocationDataGeocoded;
  mapCenter?: GeoCoordinates;
  distance?: number;
  geometry?: BoundingBox;
  options?: {
    shouldWidenSearch?: boolean;
    shouldWidenCache?: boolean;
  };
  knownFitters?: KnownFitterDistance[];
}

export interface KnownFitterDistance {
  id: string;
  distance: number;
  duration?: number;
}

export interface AppointmentSuggestionsApi {
  appointments: Appointment[];
  fitterId: string;
  dossierId: string;
}

export interface NotifyAppointmentApi {
  dossierId: string;
  notifType: NotifyAction;
}

export function getLocationData(fitter: Fitter): LocationDataGeocoded {
  return {
    isKnownAddress: true,
    locationProvider: fitter.google ? 'GOOGLE' : 'NONE',
    placeId: fitter.google?.place_id,
    address: fitter.address,
    isCompleteAddress: true,
    addressElements: {
      streetName: fitter.address,
      postalCode: fitter.cp,
      city: fitter.city,
    },
    geoCoordinates: {
      lat: fitter?.location.lat,
      lon: fitter?.location.lon,
    },
    timezone: fitter.timezone,
  };
}
